<template>
  <div class="order">
    <div class="order_nav">
      <navbar
        title="我的订单"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="all">
      <allOrder />
    </div>
  </div>
</template>
<script>
import navbar from "../accountAgent/components/nav-bar.vue";
import allOrder from "./allOrder.vue";
export default {
  components: {
    navbar,
    allOrder,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.order {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .order_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .all {
    padding-top: 8.8rem;
    box-sizing: border-box;
    height: 100%;
  }
}
</style>




